import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Button } from '@/components/ui/button';
import { Wallet, TrendingUp, ArrowRight } from 'lucide-react';

interface BudgetWidgetProps {
  totalBudget: number;
  spent: number;
}

const BudgetWidget = ({ totalBudget, spent }: BudgetWidgetProps) => {
  const percentage = totalBudget > 0 ? Math.min((spent / totalBudget) * 100, 100) : 0;
  const remaining = totalBudget - spent;

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <Card className="shadow-card border-border/50">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-medium flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-accent/10 flex items-center justify-center">
              <Wallet className="w-4 h-4 text-accent" />
            </div>
            Presupuesto
          </CardTitle>
          <span className="text-xs text-muted-foreground bg-muted px-2 py-1 rounded-full">
            {percentage.toFixed(0)}% usado
          </span>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Gastado</span>
            <span className="font-medium text-foreground">{formatCurrency(spent)}</span>
          </div>
          <Progress value={percentage} className="h-2" />
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Total</span>
            <span className="font-medium text-foreground">{formatCurrency(totalBudget)}</span>
          </div>
        </div>
        
        <div className="pt-3 border-t border-border">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Disponible</span>
            <div className="flex items-center gap-1">
              <TrendingUp className="w-4 h-4 text-secondary" />
              <span className="font-serif text-lg font-medium text-secondary">
                {formatCurrency(remaining)}
              </span>
            </div>
          </div>
        </div>

        <Button variant="outline" size="sm" className="w-full" asChild>
          <Link to="/dashboard/budget">
            Ver detalles
            <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};

export default BudgetWidget;
